const toggle = document.querySelector('.header-mobile-toggle');
const header = document.querySelector('.header');
const hamburger = document.querySelector('.header-mobile-hamburger');
const mobileLinks = document.querySelector('.header-mobile-links');
const searchBtn = document.querySelector('.searchButton');
const searchBtnMobile = document.querySelector(
  '.header-mobile-btns .searchButton',
);
const subMenuBtns = document.querySelectorAll(
  '.has-submenu .mc__navbar__trigger',
);

toggle?.addEventListener('click', () => {
  hamburger?.classList.toggle('open');
  searchBtnMobile?.parentElement?.classList.toggle('hide');
  mobileLinks?.classList.toggle('open');
  header?.classList.toggle('search-open');
});

searchBtn?.addEventListener('click', () => {
  searchBtn.parentElement?.classList.toggle('open');
  header?.classList.toggle('search-open');
});

searchBtnMobile?.addEventListener('click', () => {
  hamburger?.classList.toggle('open');
  searchBtnMobile.parentElement?.classList.toggle('hide');
  mobileLinks?.classList.toggle('open');
  header?.classList.toggle('search-open');
});

subMenuBtns?.forEach(btn => {
  btn.addEventListener('click', e => {
    e.target?.parentElement?.classList.toggle('open');
  });
});
